"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HBModalProvider = void 0;
exports.useHBModalContext = useHBModalContext;
exports.useHBModalController = useHBModalController;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBModalContext = /*#__PURE__*/(0, _react.createContext)(null);
var HBModalProvider = exports.HBModalProvider = function HBModalProvider(_ref) {
  var children = _ref.children;
  var modalsWarpedContext = useHBModalContext();
  var modals = (0, _react.useState)([]);

  // We need to go over the code and remove all the places that added this provider, we want all modals to be handled by the same context
  if (modalsWarpedContext) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }
  return /*#__PURE__*/_react["default"].createElement(HBModalContext.Provider, {
    value: modals
  }, children);
};
function useHBModalController() {
  var _useHBModalContext = useHBModalContext(),
    _useHBModalContext2 = (0, _slicedToArray2["default"])(_useHBModalContext, 2),
    setModals = _useHBModalContext2[1];
  function closeAllModals() {
    setModals(function (prevModals) {
      prevModals.forEach(function (modal) {
        modal.onCloseRef.current();
      });
      return [];
    });
  }
  return {
    closeAllModals: closeAllModals
  };
}
function useHBModalContext() {
  return (0, _react.useContext)(HBModalContext);
}
//# sourceMappingURL=HBModalProvider.js.map